
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/owners-clubs/[id]",
      function () {
        return require("private-next-pages/owners-clubs/[id].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/owners-clubs/[id]"])
      });
    }
  